import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { IRouteRecommendationsOrganisationDetail } from '../interfaces/route-recommendations/route-recommendation-organisation-detail';
import { IPageResult } from '../interfaces/page-result';
import { IRouteRecommendationOrganisationDetailFilter } from '../interfaces/route-recommendations/route-recommendation-organisation-detail-filter';
import { BaseDataService } from './base.data.service';
import { HttpResponsesHandlersFactory } from '../handlers/http-responses-handler';

export type RecommendationAccessType = 'portal' | 'mobile';

@Injectable({
  providedIn: 'root',
})
export class RouteAlgoAdminService extends BaseDataService {
  public url = '/api/route-recommendations-admin';

  constructor(public http: HttpClient, handlersFactory: HttpResponsesHandlersFactory) {
    super(http, handlersFactory);
  }

  getOrganisations(
    filterCommand: IRouteRecommendationOrganisationDetailFilter,
  ): Promise<IPageResult<IRouteRecommendationsOrganisationDetail>> {
    return this.http
      .get<IPageResult<IRouteRecommendationsOrganisationDetail>>(this.url + '/organisations', {
        params: this.constructHttpParams(filterCommand),
      })
      .toPromise();
  }

  setRecommendationAccessStatus(organisationId: number, enabled: boolean): Promise<any> {
    const url = `${this.url}/organisations/${organisationId}/access/${enabled}`;
    return this.http.put(url, null).toPromise();
  }
}
